import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    background: `linear-gradient(to right, #008F4D, #12223A)`,
    [theme.breakpoints.up('sm')]: {
      width: '450px'
    }
  },
  backgroundImg: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  bandContainer: {
    position: 'relative',
    paddingTop: 30,
    paddingBottom: 20
  },
  text1Container: {
    borderTopRightRadius:'20px',
    borderBottomRightRadius:'20px',
    backgroundColor: '#D52329',
    width: '320px',
    padding: 2,
  },
  whiteText: {
    color: 'white',
    textAlign: 'center'
  },
  blackText: {
    color: 'black',
    textAlign: 'center',
    fontWeight:'bold'
  },
  redText: {
    color: '#D52329',
  },
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 20
  },
  text1: {
    width: '280px',
    backgroundColor: '#005e3a',
    padding: 10,
    borderRadius: 10,
    position: 'absolute', 
    left: 0, 
    right: 0, 
    top: -35,
    marginLeft: 'auto', 
    marginRight: 'auto', 
  },
  whiteBackgroundContainer: {
    width: '350px',
    backgroundColor: '#D4EBDE',
    padding: 10,
    paddingTop: 20,
    borderRadius: 10,
    position: 'relative',
    marginTop: 50,
    textAlign: 'center'
  },
  villanuevaIconFooterContainer: {
    height: 75,
    display:'flex',
    justifyContent: 'center'
  }
}))
